import tr from './locales/tr.json';
import en from './locales/en.json';

const defaultLanguage = 'en';

export const languages = {
  tr,
  en,
};

export const getLanguage = () => {
  let currentLanguage = window.navigator.languages
    ? window.navigator.languages[0]
    : window.navigator.language;

  if (!languages[currentLanguage]) {
    currentLanguage = currentLanguage.substr(0, 2);
  }

  if (!languages[currentLanguage]) {
    currentLanguage = defaultLanguage;
  }

  return currentLanguage;
};
